import { NgModule } from '@angular/core';
import { mapToCanActivate, mapToResolve, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './service/auth/auth.guard';
import { erzeugungsanlageRoutes } from './erzeugungsanlage/erzeugungsanlage-routing.module';
import { OAuth2AuthGuard } from './service/auth/oauth2.guard';
import { ProfileResolver } from './service/auth/profile.resolver';
import { netzbetreiberRoutes } from './netzbetreiber/netzbetreiber-routing.module';
import { KontaktPageComponent } from './kontakt/kontakt-page/kontakt-page.component';
import { dashboardRoutes } from './dashboard/dashboard-routing.module';
import { netzzuordnungenRoutes } from './netzzuordnungen/netzzuordnungen-routing.module';
import { datenabfrageRoutes } from './datenabfrage/datenabfrage-routing.module';
import { settingsRoutes } from './settings/settings-routing.module';
import { RoleAuthGuard } from './service/auth/role-auth.guard';
import { UserRoles } from './domain/model/roles.enum';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: mapToCanActivate([
            OAuth2AuthGuard,
        ]),
    },
    {
        path: 'dashboard',
        children: dashboardRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'erzeugungsanlage',
        children: erzeugungsanlageRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'netzbetreiber',
        children: netzbetreiberRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'datenabfrage',
        children: datenabfrageRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'settings',
        children: settingsRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
            RoleAuthGuard,
        ]),
        data: {
            allowedRoles: [
                UserRoles.ADMIN_USER,
            ],
        },
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'netzzuordnung',
        children: netzzuordnungenRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'kontakt',
        component: KontaktPageComponent,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: '**',
        component: HomeComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                enableTracing: false,
                preloadingStrategy: PreloadAllModules,
                useHash: true,
            }),
    ],
    exports: [
        RouterModule,
    ],
    providers: [
        ProfileResolver,
    ],
})
export class AppRoutingModule {
}
